module.exports = __webpack_public_path__ + "static/media/carIcon.3acb8b51.svg";